import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// HelmetProvider must wrap the entire tree exactly once so that every page-level
// `useSeoTags()` call (Track 1A of the SEO + Next.js migration plan) shares the
// same head-tag manager. Survives the future Next.js migration — pages keep
// emitting Helmet blocks; we'll just swap the provider for next/head later.
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
